/* Leichtgefühl listicle (Shopify sections lgl-*): countdown, URL parameter forwarding, scroll to offer,
   offer selector + direct checkout, mobile buy bar. Loaded by every lgl section; runs once. */
(() => {
  'use strict';
  if (window.lglListicle) return;
  window.lglListicle = true;

  const incoming = new URLSearchParams(window.location.search);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Existing link values win; append only the first value of a new key.
  const withParams = href => {
    const url = new URL(href, window.location.href);
    for (const [key, value] of incoming) {
      if (!url.searchParams.has(key)) url.searchParams.append(key, value);
    }
    return url.href;
  };
  function forwardParams() {
    document.querySelectorAll('[data-lgl-cta]').forEach(link => {
      if (link.dataset.lglForwarded) return;
      link.href = withParams(link.getAttribute('href'));
      link.dataset.lglForwarded = 'true';
    });
    document.querySelectorAll('[data-lgl-fallback]').forEach(link => {
      link.dataset.lglFallback = withParams(link.dataset.lglFallback);
    });
  }

  // Buttons with target "offer" scroll to the offer box; without one they open the product page.
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-lgl-scroll]');
    if (!link) return;
    event.preventDefault();
    const offer = document.getElementById('lgl-offer');
    if (offer) offer.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
    else window.location.href = link.dataset.lglFallback;
  });

  // Offer selector: highlight the chosen option.
  document.addEventListener('change', event => {
    const input = event.target.closest('.lgl-price-input');
    if (!input) return;
    input.closest('.lgl-price-options').querySelectorAll('.lgl-price-option').forEach(option => {
      option.classList.toggle('is-selected', option.contains(input));
    });
  });

  // Offer button: put the chosen option in the cart and go straight to checkout.
  // Any failure falls back to the button's own link (the product page).
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-lgl-checkout]');
    if (!button) return;
    const input = button.closest('.lgl-shipping')?.querySelector('.lgl-price-input:checked');
    if (!input || !input.dataset.variant) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    const root = (button.dataset.lglRoot || '/').replace(/\/?$/, '/');
    const item = { id: Number(input.dataset.variant), quantity: Number(input.dataset.quantity) || 1 };
    if (input.dataset.sellingPlan) item.selling_plan = Number(input.dataset.sellingPlan);
        // Abo 2+1: Kaching only discounts subscription lines that carry its bundle property,
    // so the free bottle goes in as its own line.
    // Options with a Kaching bar: paid line + free line (bxgy), each carrying the bundle property.
    const bar = input.dataset.kachingBar;
    const free = Number(input.dataset.free) || 0;
    const prop = extra => ({ __kaching_bundles: JSON.stringify(Object.assign({ deal: input.dataset.kachingDeal || 'O8YR', bar, main: true }, extra)) });
    const line = (quantity, extra) => Object.assign({ id: item.id, quantity, properties: prop(extra) }, item.selling_plan ? { selling_plan: item.selling_plan } : {});
    const lglItems = bar ? [
      ...(free > 0 ? [line(free, { bxgy: true })] : []),
      line(item.quantity - free),
    ] : item.selling_plan ? [
      { id: item.id, quantity: 1, selling_plan: item.selling_plan, properties: { __kaching_bundles: JSON.stringify({ deal: 'O8YR', bar: 'p6wx', main: true, bxgy: true }) } },
      { id: item.id, quantity: item.quantity - 1, selling_plan: item.selling_plan, properties: { __kaching_bundles: JSON.stringify({ deal: 'O8YR', bar: 'p6wx', main: true }) } },
    ] : [item];
    try {
      const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      if (button.hasAttribute('data-lgl-clear-cart')) {
        const cleared = await fetch(`${root}cart/clear.js`, { method: 'POST', headers: json });
        if (!cleared.ok) throw new Error(`cart/clear ${cleared.status}`);
      }
      const added = await fetch(`${root}cart/add.js`, { method: 'POST', headers: json, body: JSON.stringify({ items: lglItems }) });
      if (!added.ok) throw new Error(`cart/add ${added.status}: ${await added.text()}`);
      const checkout = new URL(`${root}checkout`, window.location.origin);
      if (button.dataset.lglDiscount) checkout.searchParams.set('discount', button.dataset.lglDiscount);
      window.location.href = checkout.href;
    } catch (error) {
      console.error('Leichtgefühl: direct checkout failed, opening the product page instead.', error);
      button.removeAttribute('aria-busy');
      window.location.href = button.href;
    }
  });

  // Countdown to the next midnight in the bar's time zone, so it restarts every 24 hours.
  function startCountdowns() {
    document.querySelectorAll('[data-lgl-countdown]').forEach(countdown => {
      if (countdown.dataset.lglRunning) return;
      countdown.dataset.lglRunning = 'true';
      let clock;
      try {
        clock = new Intl.DateTimeFormat('en-GB', { timeZone: countdown.dataset.lglCountdown, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      } catch (error) {
        console.error(`Leichtgefühl: unknown time zone "${countdown.dataset.lglCountdown}", using Europe/Zurich.`, error);
        clock = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Zurich', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      }
      const fields = ['hour', 'min', 'sec'].map(unit => countdown.querySelector(`.lgl-countdown-${unit}-js`));
      // Hourly mode: 59:59 from the visitor's first view, then restarts every hour.
      if (countdown.dataset.lglCountdownMode === 'hourly') {
        let start = Date.now();
        try {
          start = Number(localStorage.getItem('lgl_cd_start')) || start;
          localStorage.setItem('lgl_cd_start', String(start));
        } catch (error) { /* storage blocked: count from page load */ }
        const tickHourly = () => {
          if (!countdown.isConnected) return;
          const left = 3599 - (Math.floor((Date.now() - start) / 1000) % 3600);
          [0, Math.floor(left / 60), left % 60].forEach((value, i) => {
            if (fields[i]) fields[i].textContent = String(value).padStart(2, '0');
          });
          setTimeout(tickHourly, 1000 - (Date.now() % 1000));
        };
        tickHourly();
        return;
      }
      const tick = () => {
        if (!countdown.isConnected) return;
        const now = Object.fromEntries(clock.formatToParts(new Date()).map(part => [part.type, Number(part.value)]));
        const left = 86399 - (now.hour * 3600 + now.minute * 60 + now.second);
        [Math.floor(left / 3600), Math.floor(left / 60) % 60, left % 60].forEach((value, i) => {
          fields[i].textContent = String(value).padStart(2, '0');
        });
        setTimeout(tick, 1000 - (Date.now() % 1000));
      };
      tick();
    });
  }

  // Mobile buy bar: visible from reason N (data-lgl-sticky-start) on, hidden while a buy button of
  // the last reason or the offer box is on screen. Missing reasons: start at the next rendered one.
  const mobile = window.matchMedia('(max-width: 915px)');
  const rendered = element => element.getClientRects().length > 0;
  let queued = false;
  function updateSticky() {
    queued = false;
    const sticky = document.querySelector('.lgl-sticky');
    if (!sticky) return;
    const first = Number(sticky.dataset.lglStickyStart) || 3;
    const reasons = Array.from(document.querySelectorAll('[data-lgl-reason]'));
    const start = reasons.find(element => Number(element.dataset.lglReason) >= first && rendered(element));
    const last = reasons[reasons.length - 1];
    const buyButtons = [
      ...(last ? last.querySelectorAll('.lgl-button') : []),
      ...document.querySelectorAll('#lgl-offer .lgl-button'),
    ];
    const buyVisible = buyButtons.some(element => {
      if (!rendered(element)) return false;
      const rect = element.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    });
    sticky.hidden = !mobile.matches || !start || start.getBoundingClientRect().top > window.innerHeight * 0.7 || buyVisible;
  }
  function scheduleSticky() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(updateSticky);
  }

  // Byline date: always today in the visitor's time zone (the server value may be cached).
  function setToday() {
    const today = new Date().toLocaleDateString('de-CH', { day: '2-digit', month: '2-digit', year: 'numeric' });
    document.querySelectorAll('[data-lgl-today]').forEach(element => { element.textContent = today; });
  }

  function init() {
    setToday();
    forwardParams();
    startCountdowns();
    updateSticky();
  }
  window.addEventListener('scroll', scheduleSticky, { passive: true });
  window.addEventListener('resize', scheduleSticky, { passive: true });
  mobile.addEventListener('change', scheduleSticky);
  // Theme editor re-renders single sections.
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
